import {MESSAGE_CLEAR_ALERT} from '~/frontend/src/constants';


export type ClearAlertMessageAction = {
    type : typeof MESSAGE_CLEAR_ALERT;
};

export function clearAlertMessage() : ClearAlertMessageAction {
    return {
        type: MESSAGE_CLEAR_ALERT
    };
}

export type ClearAlertMessage = typeof clearAlertMessage;
